import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pop_up applicant_chk com_pop",
  style: {"max-width":"800px"}
}
const _hoisted_2 = { class: "pop_tit _flex" }
const _hoisted_3 = { class: "sign_form custom_scroll" }
const _hoisted_4 = {
  class: "select_tab_box_wrap",
  style: {"margin-bottom":"10px"}
}
const _hoisted_5 = { class: "select_tab_box _230" }
const _hoisted_6 = {
  key: 0,
  for: "isPrivacy"
}
const _hoisted_7 = { style: {"margin-bottom":"10px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  class: "common_table custom_scroll _flex",
  style: {"height":"auto","max-height":"calc(100vh - 500px)"}
}
const _hoisted_10 = { class: "cnt" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { style: {"text-align":"left"} }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = {
  class: "cnt p_5",
  style: {"text-align":"right","padding":"0"}
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "_flex _center btn_wrap" }
const _hoisted_19 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer com_pop",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString($setup.state.item.idx ? "질문 수정" : "질문 추가"), 1),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["selected_tab", { active: $setup.state.isShowType }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isShowType = !$setup.state.isShowType))
            }, [
              _createElementVNode("span", null, _toDisplayString($setup.state.strType), 1)
            ], 2),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["tab_option", { active: $setup.state.isShowType }])
            }, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
                                $setup.state.type = 1;
                                $setup.state.strType = '객관식';
                                $setup.state.isShowType = false;
                            })
              }, " 객관식 "),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                $setup.state.type = 2;
                                $setup.state.strType = '객관식(복수형)';
                                $setup.state.isShowType = false;
                            })
              }, " 객관식(복수형) "),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                $setup.state.type = 3;
                                $setup.state.strType = '주관식';
                                $setup.state.isShowType = false;
                            })
              }, " 주관식 ")
            ], 2), [
              [_vShow, $setup.state.isShowType]
            ])
          ])), [
            [_directive_click_outside, $setup.clickoutside]
          ]),
          ($setup.state.type === 3)
            ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  id: "isPrivacy",
                  type: "checkbox",
                  placeholder: "민감정보",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.isPrivacy) = $event)),
                  "true-value": 1,
                  "false-value": 0
                }, null, 512), [
                  [_vModelCheckbox, $setup.state.isPrivacy]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("p", null, "민감정보", -1))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "질문을 입력해주세요",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.item.title) = $event))
          }, null, 512), [
            [_vModelText, $setup.state.item.title]
          ])
        ]),
        ($setup.state.type !== 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", null, [
                  _cache[16] || (_cache[16] = _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { style: {"width":"80px"} }),
                    _createElementVNode("col"),
                    _createElementVNode("col", { style: {"width":"50px"} })
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    ($setup.state.list.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            _createElementVNode("td", _hoisted_10, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "move_up _sub",
                                onClick: ($event: any) => ($setup.move(idx, true))
                              }, [...(_cache[13] || (_cache[13] = [
                                _createElementVNode("img", {
                                  src: "img/up_icon.png",
                                  alt: ""
                                }, null, -1)
                              ]))], 8, _hoisted_11),
                              _createElementVNode("button", {
                                type: "button",
                                class: "move_down _sub",
                                onClick: ($event: any) => ($setup.move(idx, false))
                              }, [...(_cache[14] || (_cache[14] = [
                                _createElementVNode("img", {
                                  src: "img/down_icon.png",
                                  alt: ""
                                }, null, -1)
                              ]))], 8, _hoisted_12)
                            ]),
                            _createElementVNode("td", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                placeholder: "질문을 입력해주세요",
                                "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
                              }, null, 8, _hoisted_14), [
                                [_vModelText, item.title]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_15, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "table_btn _gray",
                                style: {"margin-right":"0"},
                                onClick: ($event: any) => ($setup.isDelete(item.idx))
                              }, " 삭제 ", 8, _hoisted_16)
                            ])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[15] || (_cache[15] = [
                          _createElementVNode("td", { colspan: "6" }, [
                            _createElementVNode("div", {
                              class: "tb_subject",
                              style: {"text-align":"center","width":"100%"}
                            }, "등록한 신청 양식이 없습니다.")
                          ], -1)
                        ]))]))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "blue_btn",
                  style: {"padding":"0 10px","width":"100%"},
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.addCase && $setup.addCase(...args)))
                }, "선택지 추가+")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "submit_btn _130 _main_blue",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
        }, "저장")
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.isShowModal = false)),
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}